import React from 'react';

const STEPS = [
  { num: '01', title: '15-minute call', text: 'We look at your volume and software, then fix your monthly fee.' },
  { num: '02', title: 'We collect the records', text: "We request files from your previous accountant and check what's missing." },
  { num: '03', title: 'First close on the 10th', text: 'Your first monthly report arrives on the next 10th.' },
];

const OnboardingSection = () => (
  <section className="bk-onboard" id="onboarding" data-screen-label="Onboarding">
    <div className="bk-container">
      <span className="bk-pill bk-pill--dark">
        <span className="bk-dot" aria-hidden="true" />
        14-day onboarding sprint
      </span>
      <h2 className="bk-onboard-title">
        Switching accounting firms in Dubai takes 14 days.{' '}
        <span className="bk-accent">We call your old accountant, not you.</span>
      </h2>

      <ol className="bk-onboard-grid">
        {STEPS.map((step) => (
          <li className="bk-onboard-card" key={step.num}>
            <span className="bk-num">{step.num}</span>
            <h3 className="bk-onboard-card-title">{step.title}</h3>
            <p className="bk-onboard-card-text">{step.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default OnboardingSection;
